"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushPageToHistory = exports.getPageFromSearchParams = exports.PageBaseV1 = void 0;
var PageBaseV1 = /** @class */ (function () {
    function PageBaseV1(page) {
        this.total = page.total;
        this.per_page = page.per_page;
        this.current_page = page.current_page;
        this.last_page = page.last_page;
        this.next_page_url = page.next_page_url;
        this.prev_page_url = page.prev_page_url;
        this.from = page.from;
        this.to = page.to;
    }
    PageBaseV1.prototype.isLastPage = function () {
        if (this.current_page > this.last_page) {
            return true;
        }
        return this.current_page === this.last_page;
    };
    PageBaseV1.prototype.loadedPercentage = function () {
        if (this.current_page === 0) {
            return 0;
        }
        if (this.last_page === 0) {
            return 0;
        }
        return Math.floor(this.current_page * 100 / this.last_page);
    };
    return PageBaseV1;
}());
exports.PageBaseV1 = PageBaseV1;
function getPageFromSearchParams(paramName) {
    if (paramName === void 0) { paramName = 'page'; }
    var searchParams = new URLSearchParams(window.location.search);
    var pageRaw = searchParams.get(paramName);
    if (pageRaw === null) {
        return null;
    }
    return Number.parseInt(pageRaw);
}
exports.getPageFromSearchParams = getPageFromSearchParams;
function pushPageToHistory(page, paramName, search, searchParamName) {
    if (paramName === void 0) { paramName = 'page'; }
    if (searchParamName === void 0) { searchParamName = 'search'; }
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set(paramName, String(page));
    if (search) {
        searchParams.set(searchParamName, String(search));
    }
    var newRelativePath = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePath);
}
exports.pushPageToHistory = pushPageToHistory;
